// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

// TODO Есть проблемы с синхронизацией элементов первого списка 
//      идеи для улучшения:
//          - совместить items и valueOfLists (хранить itemsStr в items)
//          - переопределить TerceraComboBox.onItemsChanged => решить проблему выбора первого списка при загрузке itemsStr при нескольких WL

import { Resources } from "../../Commons/properties/Resources.ts";
import { contextMenuHandler } from "../../Utils/AppHandlers.js";
import { TerceraMessageBox } from "../screen/TerceraMessageBox.js";
import { TerceraRenameScreen } from "../screen/TerceraRenameScreen.js";
import { TerceraComboBox } from "./TerceraComboBox.js";
import { CustomEvent } from "../../Utils/CustomEvents.ts";
import { SessionSettings } from "../../Commons/SessionSettings.ts";
import { BrowserUtils } from "../../Commons/UtilsClasses/BrowserUtils.ts";


export let TerceraEditableListComboBox = TerceraComboBox.extend({
    data: function ()
    {
        return {
            valueOfLists: [],
            checkedMenuItem: null,
            storageName: null,
            saveImage: false,
            newItemPlaceholder: 'screen.renameScreen.newList.placeholder',
            renameHeader: 'screen.renameScreen.rename.header',
            newItemHeader: 'screen.renameScreen.newList.header',
            createNew: 'editableComboBox.CreateNew',
            createNewTooltip: 'editableComboBox.CreateNew.tooltip',
            removeTxtSecondPart: 'screen.remove.confirmText.secondPart',

            showLastValue: true,
            defaultValue: TerceraEditableListComboBox.VALUE_DEFAUL
        };
    },
    updateProcess: false
});

TerceraEditableListComboBox.prototype.getType = function () { return 'TerceraEditableListComboBox' };

TerceraEditableListComboBox.prototype.oncomplete = function ()
{
    TerceraComboBox.prototype.oncomplete.apply(this);

    this.observe('selectedItem', this.selectList.bind(this));

    this.OnSelectList = new CustomEvent();

    this.OnItemSave = new CustomEvent();

    let storageName = this.get('storageName')
    if (storageName)
        SessionSettings.sheetsChangedEvents[storageName].Subscribe(this.loadItemLists, this)

    this.loadItemLists(this._guid)
};

TerceraEditableListComboBox.prototype.dispose = function ()
{
    let storageName = this.get('storageName')
    if (storageName)
        SessionSettings.sheetsChangedEvents[storageName].UnSubscribe(this.loadItemLists, this)

    TerceraComboBox.prototype.dispose.apply(this);
};

TerceraEditableListComboBox.prototype.private_BtnClick = function (sender)
{
    this.showMenu()
};

TerceraEditableListComboBox.prototype.showMenu = function ()
{
    if (!this.get('enabled') || !this.get('selectedItem'))
        return;

    if (this.isMenuShown)
    {
        this.isMenuShown = !this.isMenuShown;
        contextMenuHandler.Hide();
        return true;
    }

    var width = $(this.find('div')).outerWidth();

    var offset = $(this.find('div')).offset();
    var posY = offset.top - $(window).scrollTop() + 26;
    var posX = offset.left - $(window).scrollLeft();

    var additionalParams = {
        width: this.get('listWidth') || width,
        isComboboxMenu: true,
        isEditableListComboBoxMenu: true,
        isTemplateMenu: this.get('saveImage')
    };

    this.isMenuShown = true;
    contextMenuHandler.Show(this.menuItems, posX, posY, additionalParams);
}

TerceraEditableListComboBox.prototype.smallBtnAction = function (element, key)
{
    if (key == 1)      // rename logic
        TerceraRenameScreen.show(element.text, this.renameItem.bind(this, element), Resources.getResource(this.get('renameHeader')))
    if (key == 2)      // delete logic 
        this.deleteItemConfirm(element)
    if (key == 3)      // save logic 
        this.saveItem(element)
}

TerceraEditableListComboBox.prototype.createNewClicked = function (element)
{
    let items = this.get('items'),
        len = items.length,
        placeholder = this.get('newItemPlaceholder'),
        newListNamePlaceHolder = Resources.getResource(placeholder),
        listName = newListNamePlaceHolder,
        newNameFound, ind = 0

    do
    {                 // поиск уникального имени для placeholder на rename screen-e
        ind++
        newNameFound = true
        for (var i = 0; i < len; i++)
            if (items[i].text == listName)
            {
                listName = newListNamePlaceHolder + ' ' + ind
                newNameFound = false
            }
    } while (!newNameFound)

    let header = this.get('newItemHeader')

    TerceraRenameScreen.show(listName, this.createItem.bind(this), Resources.getResource(header))
}

TerceraEditableListComboBox.prototype.createItem = function (listName)
{
    let header = this.get('newItemHeader')

    let isNameValid = this.listNameValidation(listName, Resources.getResource(header), this.createItem.bind(this), null)

    if (!isNameValid)
        return

    let items = this.get('items')
    let len = items.length

    let index = items.length - 2,
        newItem = {
            text: listName,
            value: index,
            tag: index
        }

    let allLists = this.get('valueOfLists'),
        newList = { name: listName, itemsStr: '' }
    allLists.splice(index, 0, newList)
    this.ownerID = this._guid;
    this.saveItem(newItem)

    items.splice(index, 0, newItem)
    this.set({ items: items });

    this.updateListsValue(listName, true, true, true)
    this.ownerID = null;
}

TerceraEditableListComboBox.prototype.renameItem = function (element, listName)
{
    let isNameValid = this.listNameValidation(listName, Resources.getResource(this.get('renameHeader')), this.renameItem.bind(this, element), element)

    if (!isNameValid)
        return

    let items = this.get('items')
    let len = items.length

    let selItem = this.get('selectedItem'),
        selectedText = selItem.text

    if (element.tag == selItem.value)
        selectedText = listName

    items[element.tag].text = listName
    this.set({ items: items });

    let allLists = this.get('valueOfLists')
    allLists[element.tag].name = listName

    this.updateListsValue(selectedText, true, true)
}

TerceraEditableListComboBox.prototype.saveItem = function (element)
{
    this.OnItemSave.Raise(element)

    contextMenuHandler.Hide()
}

TerceraEditableListComboBox.prototype.deleteItemConfirm = function (element)
{
    if (!element)
        return

    let items = this.get('items')
    let len = items.length

    if (items.length == 3 && !this.get('saveImage'))  // Need at least one element (+ CreateNew element + separator) except Chart Templates List
    {
        TerceraMessageBox.Show(Resources.getResource('screen.error.title'), Resources.getResource('screen.remove.lastlist'), TerceraMessageBox.msgType.Error, null, null, false, true);
        return
    }

    let self = this

    TerceraMessageBox.Show(
        Resources.getResource('screen.remove.title'),
        Resources.getResource('screen.remove.confirmText.firstPart') + "'" + element.text + "'" + Resources.getResource(this.get('removeTxtSecondPart')),
        TerceraMessageBox.msgType.Question,
        function () { self.deleteItem(element) });
}

TerceraEditableListComboBox.prototype.deleteItem = function (element)
{
    let items = this.get('items')
    let len = items.length

    let index = element.tag,
        selectedText = this.get('selectedItem').text

    items.splice(index, 1);
    this.set({ items: items });

    let allLists = this.get('valueOfLists')
    allLists.splice(index, 1)

    if (selectedText == element.text)
        this.updateListsValue(null, true)
    else
        this.updateListsValue(selectedText, true, true)
}

TerceraEditableListComboBox.prototype.resetList = function () {
    const currentList = this.get('selectedItem')
    this.selectList(currentList, null);
}

TerceraEditableListComboBox.prototype.selectList = function (newItem, oldItem)
{
    if (this.updateProcess || (this.ownerID && this._guid !== this.ownerID))
        return

    let currentList = this.get('selectedItem')

    if (!currentList || !newItem || currentList.separator) //|| oldItem && newItem.text == oldItem.text //|| oldItem && newItem.text == oldItem.text нверно ненужно
        return

    let allLists = this.get('valueOfLists'),
        list = allLists[currentList.value]

    if (this.menuItems)
    {
        if (oldItem && !oldItem.separator && newItem && newItem.text !== oldItem.text)
            this.menuItems[oldItem.value].checked = false

        if (!this.menuItems[newItem.value])
            return

        this.menuItems[newItem.value].checked = true
        this.set('checkedMenuItem', currentList.value)
    }

    if (!list)  //some troubles if edit list in other WL in same Workspace
        return

    this.updateProcess = true
    this.OnSelectList.Raise(list.itemsStr)
    this.updateProcess = false
};

TerceraEditableListComboBox.prototype.updateListsValue = function (selectedText, needSort, needRestoreSelectedItem, fromCreate = false)
{
    if (this.updateProcess)
        return

    let ID = "";
    if (fromCreate)
        ID = this._guid;

    if (needSort)
        this.sortMenuItems()

    if (needRestoreSelectedItem)
        this.restoreCorrectSelectItem(selectedText)

    let storageName = this.get('storageName')

    if (storageName && SessionSettings[storageName])
    {
        this.updateProcess = true
        SessionSettings.setSheetsData(storageName, this.get('valueOfLists'), ID)
        this.updateProcess = false
    }
}

TerceraEditableListComboBox.prototype.loadItemLists = function (ownerID)
{
    if (this.updateProcess)
        return

    this.ownerID = ownerID
    let strgName = this.get('storageName')

    if (strgName && SessionSettings[strgName])
    {
        let storage = SessionSettings[strgName];
        let allLists = storage && storage.itemsValue ? storage.itemsValue : [];
        let newCBItems = [];

        if (!allLists.length && (strgName == 'watchlistSheets' || strgName == 'savedOrdersSheets'))      // #89217 
        {
            this.setDefaultLists()
            return
        }

        for (let i = 0; i < allLists.length; i++)
            newCBItems.push({ text: allLists[i].name, value: i })
        newCBItems = newCBItems.concat(this.getDefaultCBItems())

        let selItem = this.get('selectedItem'),
            selectedText = selItem ? selItem.text : null

        this.set({
            items: newCBItems,
            valueOfLists: allLists
        }).then(function () { this.ownerID = null }.bind(this))

        if (selectedText)
        {
            this.restoreCorrectSelectItem(selectedText)

            // TODO   ёбаный костыль для синхронизации первого листа и только!
            // if (!selItem.value)
            //     this.OnSelectList.Raise(allLists[0].itemsStr)
        }
    }
    else
        this.setDefaultLists()

    this.ownerID = null
}

TerceraEditableListComboBox.prototype.listNameValidation = function (listName, renameScreenHeader, renameScreenCallBack, element)
{
    if (listName.trim() == '')
    {                               // cant add Illegal name such a "    "
        TerceraMessageBox.Show(Resources.getResource('screen.error.title'), Resources.getResource('screen.renameScreen.illegalName'), TerceraMessageBox.msgType.Error, null, null, false, true);
        TerceraRenameScreen.show(listName, renameScreenCallBack, renameScreenHeader)
        return false
    }

    let items = this.get('items')
    let len = items.length - 2

    for (var i = 0; i < len; i++)
        if (items[i].text == listName)// &&                         // проверка существования списка с таким названием
        //(!element || element.tag != items[i].value))          // #86928 
        {
            TerceraMessageBox.Show(Resources.getResource('screen.error.title'),
                Resources.getResource('screen.rename.alreadyExist.firstPart') + "'" + listName + "'" + Resources.getResource('screen.rename.alreadyExist.secondPart'),
                TerceraMessageBox.msgType.Error, null, null, false, true, null, 
                {zIndex: 2100});    // #115349 (TerceraRenameScreen.zIndex == 2000)

            TerceraRenameScreen.show(element ? element.text : listName, renameScreenCallBack, renameScreenHeader)
            return false
        }

    if (BrowserUtils.regexpEnd.test(listName) === true ||        // #86930
        BrowserUtils.regexpText.test(listName) === true ||
        BrowserUtils.regexpSymbol.test(listName) === true)
    {
        TerceraMessageBox.Show(Resources.getResource('screen.error.title'), Resources.getResource('screen.renameScreen.illegalName'), TerceraMessageBox.msgType.Error, null, null, false, true, null,
            { zIndex: 2100 });      // #115349 (TerceraRenameScreen.zIndex == 2000)
        TerceraRenameScreen.show(listName, renameScreenCallBack, renameScreenHeader)
        return false
    }

    return true
}

TerceraEditableListComboBox.prototype.restoreCorrectSelectItem = function (selectedText)
{
    let itemsAfterSort = this.get('items')
    for (let i = 0; i < itemsAfterSort.length; i++)
        if (itemsAfterSort[i].text == selectedText)
        {
            this.set('selectedItem', itemsAfterSort[i])
            break;
        }
}

TerceraEditableListComboBox.prototype.setDefaultLists = function ()
{
    let newItems = [{ text: Resources.getResource('editableComboBox.defaultList'), value: TerceraEditableListComboBox.VALUE_DEFAUL }];

    newItems = newItems.concat(this.getDefaultCBItems())

    this.set({ items: newItems })

    let list = { name: newItems[0].text, itemsStr: '' }
    this.set('valueOfLists', [list])
}

TerceraEditableListComboBox.prototype.getDefaultCBItems = function ()
{
    return [{ separator: true, value: TerceraEditableListComboBox.DEFAUL_VALUE_SEPARATOR }, { text: Resources.getResource(this.get('createNew')), value: -1, noImages: true }]
}

TerceraEditableListComboBox.prototype.getDefaultItem = function ()
{
    let defV = this.getItemByValue(this.get('selectedItem'));
    if (!defV)
        defV = this.getItemByValue(this.get('defaultValue'));

    return defV
}

TerceraEditableListComboBox.prototype.sortMenuItems = function ()
{
    var itemsAll = this.get('items'),
        items = itemsAll.slice(0, itemsAll.length - 2),
        defaultItems = itemsAll.slice(itemsAll.length - 2),
        allLists = this.get('valueOfLists')

    items.sort(function (a, b)
    {
        if (a.text > b.text)
            return 1;
        if (a.text < b.text)
            return -1;
        return 0;
    })

    for (let i = 0; i < items.length; i++)
        items[i].value = i

    allLists.sort(function (a, b)
    {
        if (a.name > b.name)
            return 1;
        if (a.name < b.name)
            return -1;
        return 0;
    })

    this.set({
        items: items.concat(defaultItems),
        valueOfLists: allLists
    })
}

TerceraEditableListComboBox.prototype.createMenuItems = function ()
{
    var items = this.get('items');
    var menuItems = [];

    var me = this
    var callback = this.private_OnMenuItemSelected.bind(this);

    var len = items.length;
    var selectedItem = this.get('selectedItem');
    var hasSaveImage = this.get('saveImage');
    for (var i = 0; i < len; i++)
    {
        var item = items[i],
            mItem = item.separator ? item : {
                text: item.text,
                style: item.style,
                tag: item.value,
                enabled: true,
                event: i + 1 < len ? callback : this.createNewClicked.bind(this),
                smallEvent: this.smallBtnAction.bind(this),
                hasImages: !item.noImages,
                hasSaveImage: hasSaveImage,
                imagewidth: this.get('imagewidth') || 25,
                canCheck: true,
                checked: selectedItem ? selectedItem.value == item.value : false, //&& this.ownerID === this._guid,
                hasPlusImg: item.noImages && hasSaveImage,
                tooltip: item.noImages ? this.get('createNewTooltip') : ''
            }

        menuItems.push(mItem)
    }

    menuItems[menuItems.length - 1].text = Resources.getResource(this.get('createNew'))

    return menuItems;
};

TerceraEditableListComboBox.prototype.localize = function ()
{
    let menu = this.menuItems

    if (menu)
        menu[menu.length - 1].text = Resources.getResource(this.get('createNew'))
}

TerceraEditableListComboBox.prototype.InitByDefaultOrFirst = function ()
{
    let defV = this.getItemByValue(TerceraEditableListComboBox.VALUE_DEFAUL)
    if (!defV)
    {
        let items = this.get('items');
        if (items)
            defV = items[0];
    }
    if (!defV)
        return;

    this.restoreCorrectSelectItem(defV.text)
}

TerceraEditableListComboBox.DEFAUL_VALUE_SEPARATOR = 1433; //значение для сепаратора (рандомное значение из головы вредной Женщины)
TerceraEditableListComboBox.VALUE_DEFAUL = 0; //значение для default (рандомное значение из головы вредного Жирдяя)